import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

import { Container, Col, Row, Table, Form, Alert, Button, Modal, Dropdown } from "react-bootstrap";

import {
    ExclamationCircle,
    ExclamationTriangleFill,
    Check2
  } from "react-bootstrap-icons";

import NavbarComponent from '../components/NavbarComponent';
import FooterComponent from '../components/FooterComponent';
import LoadingComponent from "../components/LoadingComponent";
import ServerErrorComponent from "../components/ServerErrorComponent";
import AuthErrorComponent from "../components/AuthErrorComponent";
import AlertErrorComponent from "../components/AlertErrorComponent";
import AlertComponent from "../components/AlertComponent";
import AlertSuccessComponent from "../components/AlertSuccessComponent";

import {
    setI18N
  } from "../js/actions/index";

import {
    UI, I18N_LOCALES, ZH_HK, EN, GOODS_NAME, GOODS_NAME_ALIAS, GOODS_CODE, UNITS, BRANCHES, DEPARTMENTS, STORAGES, BUSINESSES, SUPPLIERS, PRODUCTS
} from "../constants/GlobalConstant";

import {
    SUCCESS,
    NO_USER_FOUND,
    FAILED_AUTHENTICATE_TOKEN,
} from "../constants/ApiResult";

import {
    geti18nLabels,
    geti18nTranslations,
    puti18nTranslations,
    posti18nTranslations,
    posti18nUnits,
    geti18nGoods,
    posti18nProducts,
    posti18nBusiness,
    posti18nBusinessSuppliers
} from "../services/i18n";

import {
    getSupplierInventoryByBusinessId
} from "../services/Supplier";

import {
    getUnits
} from "../services/Units";

import {
    getBusinessDetails,
    getBusinessSuppliers
} from "../services/Business";

import I18N from "../js/i18n";

function mapDispatchToProps(dispatch) {
    return {
      setI18N: payload => dispatch(setI18N(payload))
    };
}

const TRANSLATION_MODES = [{
    "id":1,
    "label":'User Interface'
},{
    "id":2,
    "label":'Units'
},{
    "id":3,
    "label":'Products'
},{
    "id":4,
    "label":'Business'
},{
    "id":5,
    "label":'Supplier'
}];

const COL_WIDTH = 200;

class I18NTranslations extends React.Component {

    constructor(props) {
        super(props);
    
        this.state = {
            isLoading:false,
            serverError:false,
            alertErrorLabel:null,
            authError:false,
            isSuccess:false,
            data:null,
            dataUI:null,
            filterName:"",
            isConfirmModal:false,
            isConfirmLoading:false,
            mode:null, // change back to null
            dataUnits:null,
            dataProducts:null,
            supplierId:null,
            dataSupplierProducts:null,
            dataSupplierProductsUI:null,
            dataBusiness:null,
            dataSuppliers:null,
            isAddUIModal:false,
            dataAddUI:{
                "name":"",
                "translations":{}
            }
        };
      }

    componentDidMount = async () => {
        console.log('Component did mount');

        // dev code remove!
        //this.handleSelectTranslation(1);
    }

/*
API
*/

handleResponseAPI = (data) => {
    if (
        [NO_USER_FOUND, FAILED_AUTHENTICATE_TOKEN].indexOf(
          data
        ) > -1
      ) {
        this.setState({
          isLoading: false,
          authError: true,
        });
        return;
      }
}

handleServerErrorAPI = (err) => {
    this.setState(
      {
        isLoading: false,
        serverError: true,
      },
      () => {
        if (err) console.log(err);
      }
    );
  };

  /*
  handleErrorAPI = (err) => {
    this.setState(
      {
        isLoading: false,
        errorAPI: true,
      },
      () => {
        if (err) console.log(err);
      }
    );
  };
  

  handleAuthError = (err) => {
    this.setState(
      {
        isLoading: false,
        authError: true,
      },
      () => {
        if (err) console.log(err);
      }
    );
  };
  */

/*
Service Calls
*/

// (GET) Units

getUnits = () => {
    try {
        const props = {
          token: this.props.auth.token
        };
        return getUnits(props);
    } catch (err) {
        this.handleServerErrorAPI(err);
    }    
}

// (GET) i18n Labels

getI18NLabels = () => {
    try {
      const props = {
        token: this.props.auth.token
      };
      return geti18nLabels(props);
    } catch (err) {
      this.handleServerErrorAPI(err);
    }    
}

// (GET) i18n Translations

getI18NTranslations = () => {
    try {
      const props = {
        token: this.props.auth.token
      };
      return geti18nTranslations(props);
    } catch (err) {
      this.handleServerErrorAPI(err);
    }    
  }

// (PUT) i18n Translations
putI18NTranslations = () => {
    try {
      const props = {
        token: this.props.auth.token,
        payload: this.getConfirmTranslations()
      };
      return puti18nTranslations(props);
    } catch (err) {
      this.handleServerErrorAPI(err);
    }    
}

// (POST) i18n Translations
postI18NTranslations = () => {
    try {
      const props = {
        token: this.props.auth.token,
        payload: this.state.dataAddUI
      };
      return posti18nTranslations(props);
    } catch (err) {
      this.handleServerErrorAPI(err);
    }    
}

// (POST) Units
postI18NUnits = () => {
    try {
        const props = {
          token: this.props.auth.token,
          payload: this.getConfirmUnitTranslations()
        };
        return posti18nUnits(props);
    } catch (err) {
        this.handleServerErrorAPI(err);
    }    
}

// (GET) Supplier Inventory By BusinessId
getSupplierInventoryByBusinessId = () => {
    try {
        const props = {
          token: this.props.auth.token,
          businessId: this.props.auth.businessId
        };
        return getSupplierInventoryByBusinessId(props);
    } catch (err) {
        this.handleServerErrorAPI(err);
    }    
}

// (GET) i18n Goods
geI18NGoods = () => {
    try {
        const props = {
          token: this.props.auth.token,
          supplierId: this.state.supplierId
        };
        return geti18nGoods(props);
    } catch (err) {
        this.handleServerErrorAPI(err);
    }    
}

// (POST) Products
postI18NProducts = () => {
    try {
        const props = {
          token: this.props.auth.token,
          payload: this.getConfirmSupplierProductsTranslations()
        };
        return posti18nProducts(props);
    } catch (err) {
        this.handleServerErrorAPI(err);
    }    
}

// (GET) Business Details
getBusinessDetails = () => {
    try {
        const props = {
          token: this.props.auth.token,
          businessId: this.props.auth.businessId
        };
        return getBusinessDetails(props);
    } catch (err) {
        this.handleServerErrorAPI(err);
    }    
}

// (POST) Business Details
postI18NBusiness = () => {
    try {
        const props = {
          token: this.props.auth.token,
          payload: this.getConfirmBusinessTranslations()
        };
        return posti18nBusiness(props);
    } catch (err) {
        this.handleServerErrorAPI(err);
    }    
}

// (GET) Business Suppliers
getBusinessSuppliers = () => {
    try {
        const props = {
          token: this.props.auth.token,
          businessId: this.props.auth.businessId
        };
        return getBusinessSuppliers(props);
    } catch (err) {
        this.handleServerErrorAPI(err);
    }    
}

// (POST) Business Suppliers
postI18NBusinessSuppliers = () => {
    try {
        const props = {
          token: this.props.auth.token,
          payload: this.getConfirmSupplierTranslations()
        };
        return posti18nBusinessSuppliers(props);
    } catch (err) {
        this.handleServerErrorAPI(err);
    }    
}

// ============

/*
Loading
*/
    isLoading = () => {
        if(this.state.isLoading) {
            return true;
        }

        return false;
    }

/*
Severe Error
*/

    isSevereError = () => {
        if(this.state.authError || this.state.serverError) {
            return true;
        }
        return false;
    }

/*
Common
*/

// Translations Title
getTranslationsTitle = () => {
    let filter = TRANSLATION_MODES.filter( (obj) => obj.id === this.state.mode )[0];
    if(filter) {
        return filter.label;
    }
    return "Select translation";
}

// Select Translation
handleSelectTranslation = (mode) => {
    this.setState({
        isLoading:true,
        data:null,
        dataUI:null,
        dataUnits:null,
        mode:parseInt(mode),
        filterName:""
    }, () => {
        let res = null;
        
        (async () => {
            if(this.state.mode === 1) {
                res = await this.getI18NTranslations();
                this.handleResponseAPI(res.data.result);
                //this.setStateData(res.data.data);

                this.setState({
                    isLoading:false,
                    data:res.data.data,
                    dataUI:res.data.data
                });

            } else if(this.state.mode === 2) {
                res = await this.getUnits();
                this.handleResponseAPI(res.data.result);

                // latest i18n
                let i18nUI = await this.getI18NLabels();
                this.handleResponseAPI(res.data.result);

                this.props.setI18N({
                    "property":UI,
                    "value":i18nUI.data.data
                }).then( () => {
                    this.setState({
                        isLoading:false,
                        dataUnits:res.data.data,
                        dataUI:this.props.i18n
                    });
                });
            } else if(this.state.mode === 3) {
                res = await this.getSupplierInventoryByBusinessId();
                this.handleResponseAPI(res.data.result);

                this.setState({
                    isLoading:false,
                    dataProducts:res.data.data
                });
            } else if(this.state.mode === 4) {
                res = await this.getBusinessDetails();
                this.handleResponseAPI(res.data.result);

                let dataBusiness = res.data.data;

                if(dataBusiness) {

                    // latest i18n
                    let i18nUI = await this.getI18NLabels();
                    this.handleResponseAPI(res.data.result);

                    this.props.setI18N({
                        "property":UI,
                        "value":i18nUI.data.data
                    }).then( () => {
                        let dataUI = JSON.parse(JSON.stringify(this.props.i18n));

                        I18N_LOCALES.forEach( (locales) => {
                            let locale = locales.locale;
                            if(locale !== ZH_HK) {
                                if(!Object.keys(dataUI[locale][BUSINESSES]).length) {
        
                                    let branchData = [];
        
                                    dataBusiness[BRANCHES].forEach( (branch) => {
                                        branchData.push({
                                            "BranchId":branch.branchId,
                                            "BranchName":"",
                                            "Address":"",
                                            [DEPARTMENTS]:[],
                                            [STORAGES]:[]
                                        })
                                    });
        
                                    dataUI[locale][BUSINESSES].push({
                                        "BusinessId":this.props.auth.businessId,
                                        "BusinessName":"",
                                        [BRANCHES]:branchData
                                    });
                                  
                                }
                            }
                        });
        
                        this.setState({
                            isLoading:false,
                            dataUI:dataUI,
                            dataBusiness:dataBusiness
                        });
                    });
                }
            } else if(this.state.mode === 5) {
                res = await this.getBusinessSuppliers();
                this.handleResponseAPI(res.data.result);

                // latest i18n
                let i18nUI = await this.getI18NLabels();
                this.handleResponseAPI(res.data.result);

                this.props.setI18N({
                    "property":UI,
                    "value":i18nUI.data.data
                }).then( () => {
                    this.setState({
                        isLoading:false,
                        dataUI:this.props.i18n,
                        dataSuppliers:res.data.data
                    });
                });
            }
        })();
    })
}

// Set State Data (API Response)
setStateData = (data) => {
    this.setState({
        isLoading:false,
        data:data,
        dataUI:data
    });
}

// ========================
// Translations Start
// 

/*
Filter Name
*/

    handleFilterName = (value) => {
        this.setState({
            filterName:value
        });
    }

/*
On Change Translation
*/

 handleChangeTranslation =  (name, locale, translation) => {
    let dataUI = JSON.parse(JSON.stringify(this.state.dataUI));
    let index = this.state.dataUI[name].findIndex( (obj => obj.locale === locale ));
    if(index > -1) {
        dataUI[name][index].translation = translation;    
    }
    this.setState({
        dataUI:dataUI
    });
 }

/*
Translation Save
*/

    isTranslationSave = (name, locale, translation) => {
        // compare with the original translation
        let filter = this.state.data[name].filter( (obj => obj.locale === locale ))[0];
        if(filter && filter.translation !== translation) {
            return true;
        } 
        return false;
    }

/*
Translation Placeholder
*/

    getTranslationPlaceholder = (name, locale) => {
        // compare with the original translation
        let filter = this.state.data[name].filter( (obj => obj.locale === locale ))[0];
        if(filter) {
            return filter.translation;
        } 
        return "";    
    }

/*
Save
*/
    handleClickSave = () => {
        this.setState({
            isConfirmModal:true
        });
    }

/*
Confirm
*/
    handleConfirmModalClose = () => {
        this.setState({
            isConfirmModal:false,
            isConfirmLoading:false
        });
    }

    handleConfirmModalSave = () => {
        this.setState({
            isConfirmLoading:true
        }, async () => {
            if(this.state.mode === 1) {
            
                // UI Translation
        
                    await this.putI18NTranslations();

                    this.setState({
                        data:this.state.dataUI
                    }, async () => {
                        this.handleConfirmModalClose();
                        alert('Save Successful');
                    
                        let res = await this.getI18NLabels();
                        this.handleResponseAPI(res.data.result);
                
                        this.props.setI18N({
                            "property":UI,
                            "value":res.data.data
                        });
                    });
            
                } else if(this.state.mode === 2) {
                // Unit
                    await this.postI18NUnits();

                    this.setState({
                        data:this.state.dataUI
                    }, async () => {
                        this.handleConfirmModalClose();
                        alert('Save Successful');
        
                        this.props.setI18N({
                            "property":UNITS,
                            "value":this.state.dataUI
                        });
                    });
                    
                } else if(this.state.mode === 3) {
                // Product
                    await this.postI18NProducts();

                    this.setState({
                        dataSupplierProducts:this.state.dataSupplierProductsUI
                    }, async () => {
                        this.handleConfirmModalClose();
                        alert('Save Successful');
                    });
        
                } else if(this.state.mode === 4) {
                // Business (business, branch, department, storage)
                    await this.postI18NBusiness();

                    this.props.setI18N({
                        "property":BUSINESSES,
                        "value":this.state.dataUI
                    }).then( () => {
                        this.handleConfirmModalClose();
                        alert('Save Successful');
                    });
                } else if(this.state.mode === 5) {
                    await this.postI18NBusinessSuppliers();
                    
                    this.props.setI18N({
                        "property":SUPPLIERS,
                        "value":this.state.dataUI
                    }).then( () => {
                        this.handleConfirmModalClose();
                        alert('Save Successful');
                    });
                }
        });
    }

// Get Confirm Translations
    getConfirmTranslations = () => {
        let data = {};

        Object.keys(this.state.dataUI).map( (key) => {
            this.state.dataUI[key].forEach( (row, index) => {
                if(this.isTranslationSave(key, row.locale, row.translation)) {
                    if(!data[key]) {
                        data[key] = [row];
                    } else {
                        data[key].push(row);
                    }
                }
            });
        });

       return data;
    }

// 
// Translations End
// ========================

// =========================
// Translation Name Add
//

handleOnClickAddUI = () => {
    this.setState({
        isAddUIModal:true
    });
}

handleAddUIModalClose = () => {
    this.setState({
        isAddUIModal:false,
        dataAddUI:{
            "name":"",
            "translations":{}
        }
    });
}

handleOnChangeAddUIName = (value) => {
    let data = JSON.parse(JSON.stringify(this.state.dataAddUI));
    data["name"] = value.toUpperCase();
    this.setState({
        dataAddUI:data
    });
}

handleOnChangeAddUITranslation = (locale, translation) => {
    let data = JSON.parse(JSON.stringify(this.state.dataAddUI));

    data["translations"][locale] = translation;

    this.setState({
        dataAddUI:data
    });
}

disabledAddUIModal = () => {
    if(this.isTranslationSaveNameError() || this.isTranslationNameFormatError()) {
        return true;
    }

    let translations = true;
    I18N_LOCALES.forEach( (locales) => {
        if(!this.state.dataAddUI.translations[locales.locale]){
            translations = false;
        }
    });

    if(this.state.dataAddUI.name && translations) {
        return false;
    }
    return true;
}

handleAddUIModalSave = async () => {
    const res = await this.postI18NTranslations();
    let dataUI = JSON.parse(JSON.stringify(this.state.dataUI));
    // sort locale asc
    let array = res.data.data[this.state.dataAddUI.name].sort((a, b) => a.locale.toLowerCase() > b.locale.toLowerCase() ? 1 : -1);
    dataUI[this.state.dataAddUI.name] = array;
    
    this.setState({
        data:dataUI,
        dataUI:dataUI,
    }, async () => {
        this.handleAddUIModalClose();
        alert('Save Successful');
    
        let res = await this.getI18NLabels();
        this.handleResponseAPI(res.data.result);

        this.props.setI18N({
            "property":UI,
            "value":res.data.data
        });
    });
}

isTranslationSaveNameError = () => {
    let error = false;
    if(this.state.dataAddUI.name) {
        Object.keys(this.state.data).forEach( (key) => {
            if(this.state.dataAddUI.name.toLowerCase() === key.toLowerCase()) {
                error = true;
            }
        });
    }
    return error;
}

isTranslationNameFormatError = () => {
    const regexp = /^[a-zA-Z0-9_]+$/;

    if(!this.state.dataAddUI.name) {
        return false;
    }

    if (this.state.dataAddUI.name.search(regexp) === -1) {
        return true;
    }
    return false;
}

//
// Translation Add End
// =========================

// ========================
// Unit Start
//

    getUnitTranslation = (locale, id) => {
        if(this.state.dataUI && this.state.dataUI[locale] && this.state.dataUI[locale][UNITS]) {
            let filter = this.state.dataUI[locale][UNITS].filter( (obj) => obj.id === id )[0];
            if(filter) {
                return filter.translation;
            }
        }
        return "";
    }

    handleOnChangeUnit = (locale, id, translation, unitName) => {
        let dataUI = JSON.parse(JSON.stringify(this.state.dataUI));
        if(dataUI[locale] && dataUI[locale][UNITS]) {
            let index = dataUI[locale][UNITS].findIndex( (obj) => obj.id === id );
            if(index > -1) {
                dataUI[locale][UNITS][index].translation = translation;
            } else {
                dataUI[locale][UNITS].push({
                    id:id,
                    locale:locale,
                    translation:translation,
                    unitName:unitName
                })
            }
            this.setState({
                dataUI:dataUI
            })
        }
    }

    isUnitTranslationSave = (locale, id, translation) => {
        let data = JSON.parse(JSON.stringify(this.props.i18n));
        if(data[locale] && data[locale][UNITS]) {
            let filter = data[locale][UNITS].filter( (obj) => obj.id === id )[0];
            if(!filter && translation) {
                return {
                    insert:true
                }
            }
            if(filter && filter.translation !== translation) {
                return {
                    insert:false
                }
            }
        }
        return false;
    }

    getConfirmUnitTranslations = () => {
        let data = [];
        if(this.state.dataUI) {
            Object.keys(this.state.dataUI).forEach( (key) => {
                if(this.state.dataUI[key] && this.state.dataUI[key][UNITS]) {
                    this.state.dataUI[key][UNITS].forEach( (unit) => {
                        let isUnitSave = this.isUnitTranslationSave(key, unit.id, unit.translation);
                        if(isUnitSave) {
                            data.push({
                                insert:isUnitSave.insert,
                                id:unit.id,
                                translation:unit.translation,
                                locale:key,
                                unitName:unit.unitName
                            });
                        }
                    });
                }
            });
        }
        return data;
    }

// 
// Unit End
// ========================

// ========================
// Products Start
//

    getSupplierTitle = (data) => {
        let supplierTitle = this.getSupplierName(data);
        
        if(supplierTitle) {
            return supplierTitle;
        }
        return "Select Supplier";
    }

    getSupplierName = (data) => {
        let filter = data.filter( (obj) => obj.SupplierId === this.state.supplierId )[0];
        if(filter) {
            return filter.SupplierName;
        }
        return;
    }

    handleSelectSupplier = (supplierId) => {
        this.setState({
            isLoading:true,
            supplierId:parseInt(supplierId)
        }, async () => {
            let res = await this.geI18NGoods();
            
            let data = {};
            if(!Object.keys(res.data.data).length) {
                I18N_LOCALES.forEach( (locales) => {
                    data[locales.locale] = {
                        [PRODUCTS]:[]
                    };
                });
            } else {
                data = res.data.data;
            }

            this.handleResponseAPI(res.data.result);
            this.setState({
                dataSupplierProducts:data,
                dataSupplierProductsUI:data,
                isLoading:false
            });
        });
    }

    getSupplierProducts = () => {
        let filter = this.state.dataProducts.filter( (obj) => obj.SupplierId === this.state.supplierId )[0];
        if(filter && filter.products && filter.products.length) {
            return filter.products;
        }
        return [];
    }

    getSupplierProductTranslation = (locale, goodsId, property) => {
        if(this.state.dataSupplierProductsUI[locale] && this.state.dataSupplierProductsUI[locale].products) {
            let filter = this.state.dataSupplierProductsUI[locale].products.filter( (obj) => obj.GoodsId === goodsId)[0];
            if(filter) {
                return filter[property];
            }
        }
        return "";
    }

    getSupplierProductProperty = (goodsId, property) => {
        let products = this.getSupplierProducts();
        if(products.length) {
            let filter = products.filter( (obj) => obj.GoodsId === goodsId )[0];
            if(filter) {
                return filter[property];
            }
        }
        return "";
    }

    handleOnChangeSupplierProduct = (locale, goodsId, property, translation) => {
        if(this.state.dataSupplierProductsUI[locale] && this.state.dataSupplierProductsUI[locale].products) {
            let index = this.state.dataSupplierProductsUI[locale].products.findIndex( (obj) => obj.GoodsId === goodsId);
            let dataSupplierProductsUI = JSON.parse(JSON.stringify(this.state.dataSupplierProductsUI));
            if(index > -1) {
                dataSupplierProductsUI[locale].products[index][property] = translation;
            } else {
                if(property === GOODS_NAME) {
                    dataSupplierProductsUI[locale].products.push({
                        "GoodsId":goodsId,
                        "GoodsName":translation,
                        "GoodsNameAlias":""
                    });
                } else if(property === GOODS_NAME_ALIAS) {
                    dataSupplierProductsUI[locale].products.push({
                        "GoodsId":goodsId,
                        "GoodsName":"",
                        "GoodsNameAlias":translation
                    });
                }
            }
            this.setState({
                dataSupplierProductsUI:dataSupplierProductsUI
            });
        }
        return;
    }

    isSupplierProductSave = (locale, goodsId, property, translation) => {
        if(this.state.dataSupplierProducts[locale] && this.state.dataSupplierProducts[locale].products) {
            let index = this.state.dataSupplierProducts[locale].products.findIndex( (obj) => obj.GoodsId === goodsId );
            if(index === -1 && translation){
                return {
                    insert:true
                }
            }
            if(index > -1 && this.state.dataSupplierProducts[locale].products[index][property] !== translation) {
                return {
                    insert:false
                }
            }
        }
        return false;
    }

    getConfirmSupplierProductsTranslations = () => {
        let data = [];
        if(this.state.dataSupplierProductsUI) {
            Object.keys(this.state.dataSupplierProductsUI).forEach( (locale) => {
                this.state.dataSupplierProductsUI[locale].products.forEach( (row) => {
                    let isSave = this.isSupplierProductSave(locale, row.GoodsId, GOODS_NAME, row.GoodsName) || this.isSupplierProductSave(locale, row.GoodsId, GOODS_NAME_ALIAS, row.GoodsNameAlias);
                    if(isSave) {
                        data.push({
                            "insert":isSave.insert,
                            "GoodsId":row.GoodsId,
                            "GoodsName":!row.GoodsName ? "" : row.GoodsName,
                            "GoodsNameAlias":!row.GoodsNameAlias ? "" : row.GoodsNameAlias,
                            "locale":locale
                        });
                    } 
                });
            });
        }

        data.sort((a,b) => (a.GoodsId > b.GoodsId) ? 1 : ((b.GoodsId > a.GoodsId) ? -1 : 0));

        return data;
    }

// 
// Products End
// ========================


// ========================
// Business
//

    getBusinessIndex = (locale, businessId, data) => {
        if(data[locale][BUSINESSES] && data[locale][BUSINESSES].findIndex) {
            return data[locale][BUSINESSES].findIndex( (obj) => obj.BusinessId === businessId);
        }
        return -1;
    }

    getBusinessTranslation = (locale, businessId, property) => {
        let index = this.getBusinessIndex(locale, businessId, this.state.dataUI);
        if(index > -1 && this.state.dataUI[locale][BUSINESSES][index]) {
            return this.state.dataUI[locale][BUSINESSES][index][property];
        }
        return;
    }

    handleOnChangeBusinessTranslation = (locale, businessId, property, translation) => {
        let dataUI = JSON.parse(JSON.stringify(this.state.dataUI));
        let index = this.getBusinessIndex(locale, businessId, dataUI);
        if(index > -1) {
            dataUI[locale][BUSINESSES][index][property] = translation;
            this.setState({
                dataUI:dataUI
            });
        }
        return;
    }

    isBusinessTranslationSave = (locale, businessId, property, translation) => {
        let businessIndex = this.getBusinessIndex(locale, businessId, this.props.i18n);

        if(businessIndex === -1 && translation) {
            return {
                "insert":true
            }
        }

        if(businessIndex > -1 && this.props.i18n[locale][BUSINESSES].length &&  this.props.i18n[locale][BUSINESSES][businessIndex][property] !== translation) {
            return {
                "insert":false
            }
        }

        return;
    }

    // Service Data
    getConfirmBusinessTranslations = () => {
        let data = [];
        let businessId = this.state.dataBusiness.businessId;

        I18N_LOCALES.map( (locales, index) => {
            let locale = locales.locale;
            if(locales.locale !== ZH_HK) {

                if(this.state.dataBusiness) {
                    let businessName = this.getBusinessTranslation(locale, businessId, "BusinessName");
                    let businessSave = this.isBusinessTranslationSave(locale, businessId, "BusinessName", businessName);
                    
                    if(businessSave) {
                        data.push({
                            "businessId":businessId,
                            "businessName":businessName,
                            "insert":businessSave.insert,
                            "locale":locale
                        });
                    } else {
                        // no i18n set for is_business_i18n
                        if(!Object.keys(this.props.i18n[locale][BUSINESSES]).length && !businessSave) {
                            data.push({
                                "businessId":businessId,
                                "businessName":businessName,
                                "insert":true,
                                "locale":locale
                            }); 
                        }
                    }
                    
                    this.state.dataUI[locale][BUSINESSES].forEach( (business) => {
                        let businessId = business.BusinessId;

                        if(business[BRANCHES]) {
                            business[BRANCHES].forEach( (branch) => {
                                let branchId = branch.BranchId;

                                let branchName = this.getBranchTranslation(locale, businessId, branchId, "BranchName");
                                let address = this.getBranchTranslation(locale, businessId, branchId, "Address");

                                let branchNameSave = this.isBusinessBranchTranslationSave(locale, businessId, branchId, "BranchName", branchName);
                                let addressSave = this.isBusinessBranchTranslationSave(locale, businessId, branchId, "Address", address);

                                let insert = branchNameSave ? branchNameSave : addressSave;

                                if(branchNameSave || addressSave) {
                                    data.push({
                                        "businessId":businessId,
                                        "branchId":branchId,
                                        "branchName":branchName,
                                        "address":address,
                                        "insert":insert.insert,
                                        "locale":locale
                                    });
                                } else {
                                    // no i18n set for is_business_i18n
                                    if(!Object.keys(this.props.i18n[locale][BUSINESSES]).length && (!branchNameSave || !addressSave)) {
                                        data.push({
                                            "businessId":businessId,
                                            "branchId":branchId,
                                            "branchName":branchName,
                                            "address":address,
                                            "insert":true,
                                            "locale":locale
                                        });
                                    }
                                }
                                
                                if(branch[DEPARTMENTS]) {
                                    branch[DEPARTMENTS].forEach( (department) => {
                                        let depId = department.DepId;
                                        let depName = this.getDepartmentTranslation(locale, businessId, branchId, depId);
                                        let depSave = this.isBusinessBranchDepartmentTranslationSave(locale, businessId, branchId, depId, depName);
                                        
                                        if(depSave) {
                                            data.push({
                                                "businessId":businessId,
                                                "branchId":branchId,
                                                "depId":depId,
                                                "depName":depName,
                                                "insert":depSave.insert,
                                                "locale":locale
                                            });
                                        }

                                    });
                                }

                                if(branch[STORAGES]) {
                                    branch[STORAGES].forEach( (storage) => {
                                        let storageId = storage.StorageId;
                                        let storageName = this.getStorageTranslation(locale, businessId, branchId, storageId);
                                        let storageSave = this.isBusinessBranchStorageTranslationSave(locale, businessId, branchId, storageId, storageName);

                                        if(storageSave) {
                                            data.push({
                                                "businessId":businessId,
                                                "branchId":branchId,
                                                "storageId":storageId,
                                                "storageName":storageName,
                                                "insert":storageSave.insert,
                                                "locale":locale
                                            });
                                        }
                                    });      
                                }

                            });
                        }
                    });
                }
            }
        });

        return data;
    }

    isConfirmBusinessTranslations = () => {
        let data = this.getConfirmBusinessTranslations();
        let isConfirm = false;
        data.forEach( (obj) => {
            if(typeof obj.businessName && obj.businessName) {
                isConfirm = true;
            }
            if(typeof obj.branchName && obj.branchName || typeof obj.address && obj.address) {
                isConfirm = true;
            }
            if(typeof obj.depName && obj.depName) {
                isConfirm = true;
            }
            if(typeof obj.storageName && obj.storageName) {
                isConfirm = true;
            }
        });

        return isConfirm;
    }

    getConfirmBusinessTranslationsHTML = () => {

        let sections = {
            [BUSINESSES]:false,
            [BRANCHES]:false,
            [DEPARTMENTS]:false,
            [STORAGES]:false
        }

        let businesses = [];
        let branches = [];
        let departments = [];
        let storages = [];

        let confirmData = this.getConfirmBusinessTranslations();


        confirmData.forEach( (row) => {
            if(businesses.indexOf(row.businessId) === -1 && row.businessId) {
                businesses.push(row.businessId);
            }

            if(branches.indexOf(row.branchId) === -1 && row.branchId) {
                branches.push(row.branchId);
            }

            if(departments.indexOf(row.depId) === -1 && row.depId) {
                departments.push({
                    "BranchId":row.branchId,
                    "DepId":row.depId
                });
            }
        
            if(storages.indexOf(row.storageId) === -1 && row.storageId) {
                storages.push({
                    "BranchId":row.branchId,
                    "StorageId":row.storageId
                });
            }
        });

// business
    const isBusiness = (data, businessId) => {
        let filter = data.filter( (row) => row.businessId === businessId && typeof row.businessName !== "undefined")[0];
        if(filter) {
            if(filter.businessName) {
                return true;
            }
        }
        return false;
    }

    const getBusinessTranslations = (data, businessId, locale) => {
        let filter = data.filter( (obj) => obj.businessId === businessId && obj.locale === locale && typeof obj.businessName )[0];
        if(filter) {
            return filter.businessName;
        }
        return;
    }

// branches
    const isBranches = (data, branchId) => {
        let filter = data.filter( (row) => row.branchId === branchId && typeof row.branchName !== "undefined")[0];

        if(filter) {
            if(filter.branchName || filter.address) {
                return true;
            }
        }
        return false;
    }

    const getBranchProperty = (branchId, property) => {
        if(this.state.dataBusiness[BRANCHES] && this.state.dataBusiness[BRANCHES].filter) {
            let filter = this.state.dataBusiness[BRANCHES].filter( (branch) => branch.branchId === branchId )[0];
            if(filter) {
                return filter[property]
            }
        }
    }

    const getBranchTranslations = (data, branchId, locale, property) => {
        let filter = data.filter( (obj) => obj.branchId === branchId && obj.locale === locale && typeof obj.branchName )[0];
        if(filter) {
            return filter[property];
        }
        return;
    }

    const isBranchDepStorage = (data, branchId) => {
        if(data.length) {
            let index = data.findIndex( (obj) => obj.BranchId === branchId );
            if(index > -1) {
                return true;
            }
        }
        return false;
    }

// departments
    /*
    const isDepartments = (data, depId) => {
        if(data.filter( (row) => row.depId === depId && typeof row.depName !== "undefined")[0]) {
            return true;
        }
        return false;
    }
    */

    const getDepName = (branchId, depId) => {
        let data = this.state.dataBusiness;
        if(data && data[BRANCHES]) {
            let branch = data[BRANCHES].filter( (obj) => obj.branchId === branchId )[0];
            if(branch && branch[DEPARTMENTS]) {
                let department = branch[DEPARTMENTS].filter( (obj) => obj.DepId === depId )[0];
                if(department) {
                    return department.DepName;
                }
            }
        }
        return;
    }

    const getDepTranslation = (data, depId, locale) => {
        let filter = data.filter( (obj) => obj.depId === depId && locale === locale )[0];
        if(filter) {
            return filter.depName;
        }
        return;
    }

    const getBranchDepStorage = (data, branchId) => {
        let filter = data.filter( (obj) => obj.BranchId === branchId );
        if(filter) {
            return filter;
        }
        return [];
    }

// storages

    /*
    const isStorages = (data, storageId) => {
        if(data.filter( (row) => row.storageId === storageId && typeof row.storageName !== "undefined")[0]) {
            return true;
        }
        return false;
    }
    */

    const getStorageName = (branchId, storageId) => {
        let data = this.state.dataBusiness;
        if(data && data[BRANCHES]) {
            let branch = data[BRANCHES].filter( (obj) => obj.branchId === branchId )[0];
            if(branch && branch[STORAGES]) {
                let storage = branch[STORAGES].filter( (obj) => obj.StorageId === storageId )[0];
                if(storage) {
                    return storage.StorageName;
                }
            }
        }
        return;
    }

    const getStorageTranslation = (data, storageId, locale) => {
        let filter = data.filter( (obj) => obj.storageId === storageId && locale === locale )[0];
        if(filter) {
            return filter.storageName;
        }
        return;
    }

// Return

       return businesses.map( (businessId) => {
        return (
            <div>
                {isBusiness(confirmData, businessId) &&
                    <div>
                        <div className="mt-4">
                            <h3>Business</h3>
                            <Table bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th style={{width:`${COL_WIDTH}px`}}>Name</th>
                                        {I18N_LOCALES.map( (locales, index) => {
                                            if(locales.locale !== ZH_HK) {
                                                return <th>{`Name (${locales.locale})`}</th>
                                            }
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            {this.state.dataBusiness.businessName}
                                        </td>
                                        {I18N_LOCALES.map( (locales, index) => {
                                            if(locales.locale !== ZH_HK) {
                                                return <td>{getBusinessTranslations(confirmData, businessId, locales.locale)}</td>
                                            }
                                        })}
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </div>
                }

                {branches.map( (branchId) => {
                    return (
                    <>
                        {isBranches(confirmData, branchId)
                        ?
                        <div className="mt-4">
                            <h4>Branches</h4>
                            <Table bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th style={{width:`${COL_WIDTH}px`}}>Name</th>
                                        {I18N_LOCALES.map( (locales, index) => {
                                            if(locales.locale !== ZH_HK) {
                                                return (
                                                <>
                                                    <th>{`Name (${locales.locale})`}</th>
                                                    <th>{`Address (${locales.locale})`}</th>
                                                </>
                                            )}
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <span className="text-primary font-weight-bold">{getBranchProperty(branchId, 'branchName')}</span>
                                            <br />
                                            {getBranchProperty(branchId, 'address')}
                                        </td>
                                        {I18N_LOCALES.map( (locales, index) => {
                                            if(locales.locale !== ZH_HK) {
                                                return (
                                                <>
                                                    <td>{getBranchTranslations(confirmData, branchId, locales.locale, 'branchName')}</td>
                                                    <td>{getBranchTranslations(confirmData, branchId, locales.locale, 'address')}</td>
                                                </>
                                            )}
                                        })}
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                        :
                        <></>
                        }

                        {
                            (isBranchDepStorage(departments, branchId) || isBranchDepStorage(storages, branchId)) &&
                            <>
                                {!isBranches(confirmData, branchId) &&
                                <div className="mb-4">
                                    <h4><span className="text-primary font-weight-bold">{getBranchProperty(branchId, 'branchName')}</span></h4>
                                </div>
                                }
                            </>
                        }

                        {isBranchDepStorage(departments, branchId) &&
                        <div className="mt-4">
                            
                            <h5>Departments</h5>
                            
                            <Table bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th style={{width:`${COL_WIDTH}px`}}>Name</th>
                                        {I18N_LOCALES.map( (locales, index) => {
                                            if(locales.locale !== ZH_HK) {
                                                return (
                                                <>
                                                    <th>{`Name (${locales.locale})`}</th>
                                                </>
                                            )}
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {getBranchDepStorage(departments, branchId).map( (obj) => {
                                        return (
                                        <tr>
                                            {I18N_LOCALES.map( (locales, index) => {
                                                if(locales.locale !== ZH_HK) {
                                                    return (
                                                        <>
                                                        <td>{getDepName(branchId, obj.DepId)}</td>
                                                        <td>{getDepTranslation(confirmData, obj.DepId)}</td>
                                                        </>
                                                    )
                                                }
                                            })}
                                        </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </div>
                        }

                        {isBranchDepStorage(storages, branchId) &&
                        <div className="mt-4">
                            
                            <h5>Storages</h5>
                            
                            <Table bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th style={{width:`${COL_WIDTH}px`}}>Name</th>
                                        {I18N_LOCALES.map( (locales, index) => {
                                            if(locales.locale !== ZH_HK) {
                                                return (
                                                <>
                                                    <th>{`Name (${locales.locale})`}</th>
                                                </>
                                            )}
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {getBranchDepStorage(storages, branchId).map( (obj) => {
                                        return (
                                        <tr>
                                            {I18N_LOCALES.map( (locales, index) => {
                                                if(locales.locale !== ZH_HK) {
                                                    return (
                                                        <>
                                                        <td>{getStorageName(branchId, obj.StorageId)}</td>
                                                        <td>{getStorageTranslation(confirmData, obj.StorageId)}</td>
                                                        </>
                                                    )
                                                }
                                            })}
                                        </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </div>
                        }
                    </>
                    )                  
                })}

            </div>
        );
       });

    }

//
//
// ========================

// ========================
// Branches
//

    getBusinessBranchData = (locale, businessId, branchId, data) => {
        let i18n = JSON.parse(JSON.stringify(this.state.dataUI));

        if(data) {
            i18n = data;
        }

        if(i18n[locale][BUSINESSES]) {
            let business = i18n[locale][BUSINESSES].filter( (obj) => obj.BusinessId === businessId )[0];
            if(business && business[BRANCHES]) {
                let branch = business[BRANCHES].filter( (obj) => obj.BranchId === branchId )[0];
                return branch;
            }
        }

        return {};
    }

    getBranchIndex = (branchId, data) => {
        if(data && data[BRANCHES] && data[BRANCHES].findIndex) {
            return data[BRANCHES].findIndex( (obj) => obj.BranchId === branchId);
        }
    }

    getBranchTranslation = (locale, businessId, branchId, property) => {
        let data = this.getBusinessBranchData(locale, businessId, branchId);
        if(data && data[property]) {
            return data[property];
        }
        return "";
    }

    handleOnChangeBranchTranslation = (locale, businessId, branchId, property, translation) => {
        let dataUI = JSON.parse(JSON.stringify(this.state.dataUI));
        let businessIndex = this.getBusinessIndex(locale, businessId, dataUI);

        if(businessIndex > -1) {
            let branchIndex = this.getBranchIndex(branchId, dataUI[locale][BUSINESSES][businessIndex]);

            if(branchIndex > -1) {
                dataUI[locale][BUSINESSES][businessIndex][BRANCHES][branchIndex][property] = translation;

                this.setState({
                    dataUI:dataUI
                });
            }
        }
        return;
    }

    isBusinessBranchTranslationSave = (locale, businessId, branchId, property, translation) => {
        let businessIndex = this.getBusinessIndex(locale, businessId, this.props.i18n);

        if(businessIndex === -1 && translation) {
            return {
                "insert":true
            }
        }

        if(businessIndex > -1) {
            let branchIndex = this.getBranchIndex(branchId, this.props.i18n[locale][BUSINESSES][businessIndex]);
            if(branchIndex === -1 && translation) {
                return {
                    "insert":true
                }
            }

            if(branchIndex > -1 && this.props.i18n[locale][BUSINESSES][businessIndex][BRANCHES][branchIndex][property] !== translation) {
                return {
                    "insert":false
                }
            }
        }
        return;
    }


//
//
// ========================


// ========================
// Departments
//

    getDepIndex = (depId, data) => {
        if(data && data[DEPARTMENTS] && data[DEPARTMENTS].findIndex) {
            return data[DEPARTMENTS].findIndex( (obj) => obj.DepId === depId);
        }
        return -1;
    }

    getDepartmentTranslation = (locale, businessId, branchId, depId, data) => {
        let branch = this.getBusinessBranchData(locale, businessId, branchId, data);

        if(branch && branch[DEPARTMENTS]) {
            let department = branch[DEPARTMENTS].filter( (obj) => obj.DepId === depId )[0];
        
            if(department) {
                return department.DepName;
            }            
        }

        return ""; 
    }

    handleOnChangeDepartmentTranslation = (locale, businessId, branchId, depId, translation) => {     
        let dataUI = JSON.parse(JSON.stringify(this.state.dataUI));
        
        let businessIndex = this.getBusinessIndex(locale, businessId, dataUI);
        let businessData = dataUI[locale][BUSINESSES][businessIndex];
        if(businessIndex > -1) {
            let branchIndex = this.getBranchIndex(branchId, businessData);
            if(branchIndex > -1) {
                let branchData = businessData[BRANCHES][branchIndex];
                let depIndex = this.getDepIndex(depId, branchData);

                if(depIndex > -1) {
                    dataUI[locale][BUSINESSES][businessIndex][BRANCHES][branchIndex][DEPARTMENTS][depIndex].DepName = translation;
                } else {
                    dataUI[locale][BUSINESSES][businessIndex][BRANCHES][branchIndex][DEPARTMENTS].push({
                        "DepId":depId,
                        "DepName":translation,
                        "locale":locale
                    });
                }
                this.setState({
                    dataUI:dataUI
                });
            }
        }
    }

    isBusinessBranchDepartmentTranslationSave = (locale, businessId, branchId, depId, translation) => {
        if(this.getDepIndex(depId, this.getBusinessBranchData(locale, businessId, branchId, this.props.i18n)) === -1 && translation) {
            return {
                "insert":true
            }
        }

        if(this.getDepartmentTranslation(locale, businessId, branchId, depId, this.props.i18n) !== translation) {
            return {
                "insert":false
            }
        }

        return false;
    }



//
// Departments End
// =========================


// ========================
// Storages
//

    getStorageIndex = (storageId, data) => {
        if(data && data[STORAGES] && data[STORAGES].findIndex) {
            return data[STORAGES].findIndex( (obj) => obj.StorageId === storageId);
        }
        return -1;
    }

    getStorageTranslation = (locale, businessId, branchId, storageId, data) => {
        let branch = this.getBusinessBranchData(locale, businessId, branchId, data);

        if(branch && branch[STORAGES]) {
            let storage = branch[STORAGES].filter( (obj) => obj.StorageId === storageId )[0];
        
            if(storage) {
                return storage.StorageName;
            }
        }
        return "";   
    }

    handleOnChangeStorageTranslation = (locale, businessId, branchId, storageId, translation) => {     
        let dataUI = JSON.parse(JSON.stringify(this.state.dataUI));
        
        let businessIndex = this.getBusinessIndex(locale, businessId, dataUI);
        let businessData = dataUI[locale][BUSINESSES][businessIndex];
        if(businessIndex > -1) {
            let branchIndex = this.getBranchIndex(branchId, businessData);
            if(branchIndex > -1) {
                let branchData = businessData[BRANCHES][branchIndex];
                let storageIndex = this.getStorageIndex(storageId, branchData);
                if(storageIndex > -1) {
                    dataUI[locale][BUSINESSES][businessIndex][BRANCHES][branchIndex][STORAGES][storageIndex].StorageName = translation;
                } else {
                    dataUI[locale][BUSINESSES][businessIndex][BRANCHES][branchIndex][STORAGES].push({
                        "StorageId":storageId,
                        "StorageName":translation,
                        "locale":locale
                    });
                }
                this.setState({
                    dataUI:dataUI
                });
            }
        }
    }

    isBusinessBranchStorageTranslationSave = (locale, businessId, branchId, storageId, translation) => {
        if(this.getStorageIndex(storageId, this.getBusinessBranchData(locale, businessId, branchId, this.props.i18n)) === -1 && translation) {
            return {
                "insert":true
            }
        }

        if(this.getStorageTranslation(locale, businessId, branchId, storageId, this.props.i18n) !== translation) {
            return {
                "insert":false
            }
        }

        return false;
    }

//
// Storages End
// =========================

// =========================
// Suppliers Start
//

    getConfirmSupplierTranslations = () => {
        let data = [];
        
        Object.keys(this.state.dataUI).forEach( (locale) => {

            if(this.state.dataUI[locale][SUPPLIERS]) {
                this.state.dataUI[locale][SUPPLIERS].forEach( (obj) => {
                    let SupplierName = this.getSuppliersTranslation(obj.locale, obj.SupplierId, 'SupplierName');
                    let Address = this.getSuppliersTranslation(obj.locale, obj.SupplierId, 'Address');
                    
                    let isSaveSupplierName = this.isSuppliersTranslationSave(obj.locale, obj.SupplierId, 'SupplierName', SupplierName);
                    let isSaveAddress = this.isSuppliersTranslationSave(obj.locale, obj.SupplierId, 'Address', Address);
        
                    if(isSaveSupplierName || isSaveAddress) {
                        data.push({
                            "SupplierId":obj.SupplierId,
                            "SupplierName":obj.SupplierName,
                            "Address":obj.Address,
                            "locale":locale,
                            "insert": isSaveSupplierName ? isSaveSupplierName.insert : isSaveAddress.insert
                        })
                    }
        
                });
            }
        });

        return data;
    }

    getSuppliersTranslation = (locale, supplierId, property, data) => {
        let dataUI = this.state.dataUI;
        if(data) {
            dataUI = data;
        }

        if(dataUI[locale][SUPPLIERS]) {
            let filter = dataUI[locale][SUPPLIERS].filter( (obj) => obj.SupplierId === supplierId )[0];

            if(filter) {
                return filter[property];
            }
        }
        return "";
    }

    isSuppliersTranslationSave = (locale, supplierId, property, value) => {

        let translation = this.getSuppliersTranslation(locale, supplierId, property, this.props.i18n);

        if(this.props.i18n[locale][SUPPLIERS]) {
            let index = this.props.i18n[locale][SUPPLIERS].findIndex( (obj) => obj.SupplierId === supplierId );
            if(index > -1 && translation !== value) {
                return {
                    insert: false
                }
            }
            if(index === -1 && value) {
                return {
                    insert: true
                }
            }
        }

        return false;
    }

    handleOnChangeSuppliersTranslation = (locale, supplierId, property, value) => {
        let dataUI = JSON.parse(JSON.stringify(this.state.dataUI));
        
        if(dataUI[locale][SUPPLIERS]) {
            let index = dataUI[locale][SUPPLIERS].findIndex( (obj) => obj.SupplierId === supplierId );
       
            if(index > -1) {
                dataUI[locale][SUPPLIERS][index][property] = value;
            } else {
                dataUI[locale][SUPPLIERS].push({
                    "SupplierId":supplierId,
                    "SupplierName":property === "SupplierName" ? value : "",
                    "Address":property === "Address" ? value : "",
                    "locale":locale
                });
            }
        }

        this.setState({
            dataUI:dataUI
        });
    }

    getSuppliersProperty = (supplierId, property) => {
        let filter = this.state.dataSuppliers.filter( (obj) => obj.SupplierId === supplierId )[0];
        if(filter) {
            return filter[property];
        }
        return "";
    }

//
// Suppliers End
// =========================

/*
Render
*/
    render() {
        let rowCount = 0;

        return (
            <>
            <Container className="p-0">
                <NavbarComponent />
                <Container fluid>
                    <Row>
                        <Col className="mt-4">
                        <h1>Translations{this.state.mode && ` - ${this.getTranslationsTitle()}`}</h1>
                        </Col>
                    </Row>
                    {this.state.alertErrorLabel &&
                    <Row>
                        <Col className="mt-4">
                        <AlertErrorComponent
                            label={this.state.alertErrorLabel}
                        />
                        </Col>
                    </Row>
                    }
                    {this.state.isSuccess &&
                    <Row>
                        <Col className="mt-4">
                            <AlertSuccessComponent label="Save Successful"/>
                        </Col>
                    </Row>
                    }

                    <Row className="mt-4">
                        <Col>
                            {
                            this.isLoading()
                            ?
                            <LoadingComponent />
                            :
                    <>
                        <>
                            <div>
                                <Form.Group controlId="dropdown-i18n-navigation">
                                <Form.Label className="font-weight-bold">i18n Navigation</Form.Label>
                                <Dropdown onSelect={(value) => this.handleSelectTranslation(value)}>
                                    <Dropdown.Toggle variant="primary" id="dropdown-i18n-navigation">
                                    {this.getTranslationsTitle()}
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        {TRANSLATION_MODES.map( (row, index) => {
                                            return <Dropdown.Item key={index} eventKey={row.id}>{row.label}</Dropdown.Item>
                                        })}
                                    </Dropdown.Menu>
                                </Dropdown>
                                </Form.Group>
                            </div>
                            
                            {/*this.state.mode &&
                                <div className="mt-4">
                                    <h2>{this.getTranslationsTitle()}</h2>
                                </div>
                            */}

                            {this.isSevereError() &&
                            <div className="mt-4">
                                {this.state.authError && <AuthErrorComponent />}
                                {this.state.serverError && <ServerErrorComponent />}
                            </div>
                            }
                        </>
                        
                        {(this.state.mode === 1 && this.state.data)
                        ?
                        <>
                            <div className="mt-4">
                                <AlertComponent
                                    variant="warning"
                                    label={"Translation Guide"}
                                    body={<ul><li>{`Do not remove the translations placeholders {GOODSNAME}, {SALEPRICE}, {SELLPRICE}`}</li></ul>}
                                />
                            </div>

                            <div className="mt-4">
                                <Button
                                    onClick={() => this.handleOnClickAddUI()}
                                >
                                    Add UI Translation
                                </Button>
                            </div>

                            {Object.keys(this.state.data).length > 0 &&
                            <div className="mt-4">
                                <Table bordered hover responsive>
                                    <thead>
                                        <tr>
                                            <th>
                                            <Form.Control
                                                type="text"
                                                placeholder={"Enter in translation name"}
                                                aria-label="Translation Filter"
                                                value={this.state.filterName}
                                                onChange={(e) => this.handleFilterName(e.currentTarget.value) }
                                            />
                                            </th>
                                            {
                                                this.state.data[Object.keys(this.state.data)[0]].map( (row, index) => {
                                                    return (
                                                        <>
                                                        <th key={index}>Translation ({row.locale})</th>
                                                        </>
                                                    )
                                                })
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                        Object.keys(this.state.dataUI).map( (key) => {
                                            let match = true;
                                            if(this.state.filterName && key.toLowerCase().indexOf(this.state.filterName.toLowerCase()) === -1) {
                                                match = false;
                                            }
                                            if(match) {
                                                rowCount++;
                                                return (
                                                <tr>
                                                    <th width="20%">
                                                        {key}
                                                    </th>
                                                    {this.state.dataUI[key].map( (row, index) => {
                                                        return (
                                                            <>
                                                            <td>
                                                            <Form.Control
                                                                type="text"
                                                                aria-label="Translation"
                                                                value={row.translation}
                                                                className={`${!row.translation ? "bg-warning" : ""} ${this.isTranslationSave(key, row.locale, row.translation) ? "text-success" : ""}`}
                                                                onChange={((e) => this.handleChangeTranslation(key, row.locale, e.currentTarget.value)) }
                                                            />
                                                            </td>
                                                            </>
                                                            )
                                                        })
                                                    }
                                                </tr>);
                                            }
                                        })
                                    }
                                    </tbody>
                                </Table>
                            </div>
                            }

                            {
                            rowCount === 0
                            ?
                            <div className="mt-4">
                                <Alert className="bg-info text-white"><ExclamationCircle size={16} className="mb-1 mr-1" /><I18N type="ui" path="NO_RESULTS" def="No Results"/></Alert>
                            </div>
                            :
                            <>
                            <div className="mt-4 text-sm-right">
                                <Button 
                                    variant="warning"
                                    onClick={() => this.handleClickSave()}
                                    disabled={!Object.keys(this.getConfirmTranslations()).length ? true : false}
                                    >
                                Save
                                </Button>
                            </div>
                            <div className="my-5"></div>
                            </>
                            }
                            </>
                            :
                            <></>
                        }

                        {(this.state.mode === 2 && this.state.dataUnits)
                        ?
                        <>
                            <div className="mt-4">
                                <Table bordered hover responsive>
                                    <thead>
                                        <tr>
                                            <th>Unit</th>
                                            {I18N_LOCALES.map( (row, index) => {
                                                if(row.locale !== ZH_HK) {
                                                    return <th>Translation ({row.locale})</th>
                                                }
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.dataUnits.map( (row, index) => {
                                        return <tr>
                                            <td>{row.UnitName}</td>
                                            {I18N_LOCALES.map( (locales, index) => {
                                            if(locales.locale !== ZH_HK) {
                                                return <td>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={this.getUnitTranslation(locales.locale, row.UnitId)}
                                                        aria-label="Unit"
                                                        value={this.getUnitTranslation(locales.locale, row.UnitId)}
                                                        className={`${!this.getUnitTranslation(locales.locale, row.UnitId) ? "bg-warning" : ""} ${this.isUnitTranslationSave(locales.locale, row.UnitId, this.getUnitTranslation(locales.locale, row.UnitId)) ? "text-success" : ""}`}
                                                        onChange={(e) => this.handleOnChangeUnit(locales.locale, row.UnitId, e.currentTarget.value, row.UnitName)}
                                                    />
                                                </td>
                                            }
                                            })}
                                        </tr>
                                        })}
                                    </tbody>
                                </Table>
                            </div>

                            <div className="mt-4 text-sm-right">
                                <Button 
                                    variant="warning"
                                    onClick={() => this.handleClickSave()}
                                    disabled={this.getConfirmUnitTranslations().length ? false : true}
                                    >
                                Save
                                </Button>
                            </div>
                            <div className="my-5"></div>
                        </>
                        :
                        <></>
                        }

                        {(this.state.mode === 3 && this.state.dataProducts)
                        ?
                        <>
                            <div className="mt-4">
                                <Form.Group controlId="dropdown-supplier">
                                    <Form.Label className="font-weight-bold">Supplier</Form.Label>
                                    <Dropdown onSelect={(value) => this.handleSelectSupplier(value)}>
                                        <Dropdown.Toggle variant="secondary" id="dropdown-supplier">
                                        {this.getSupplierTitle(this.state.dataProducts)}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            {this.state.dataProducts.map( (row, index) => {
                                                return <Dropdown.Item key={index} eventKey={row.SupplierId}>{row.SupplierName}</Dropdown.Item>
                                            })}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Form.Group>
                            </div>
                            {this.state.dataSupplierProducts &&
                            <>
                            <div className="mt-4">
                                <Table bordered hover responsive>
                                    <thead>
                                        <tr>
                                            <th>
                                                <Form.Control
                                                    type="text"
                                                    placeholder={"Enter in translation filter"}
                                                    aria-label="Translation Filter"
                                                    value={this.state.filterName}
                                                    onChange={(e) => this.handleFilterName(e.currentTarget.value) }
                                                />
                                            </th>
                                            <th>Product Alias</th>
                                            {I18N_LOCALES.map( (row, index) => {
                                                if(row.locale !== ZH_HK) {
                                                    return <><th>Product Name ({row.locale})</th>
                                                    <th>Product Alias ({row.locale})</th></>
                                                }
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.getSupplierProducts().map( (row) => {

                                            const GoodsCode =this.getSupplierProductProperty(row.GoodsId,GOODS_CODE);
                                            const GoodsName = this.getSupplierProductProperty(row.GoodsId,GOODS_NAME);
                                            let match = true;
                                            if(this.state.filterName && (GoodsCode+GoodsName).toLowerCase().indexOf(this.state.filterName.toLowerCase()) === -1) {
                                                match = false;
                                            }
                                            if(match) {
                                                rowCount++;
                                                
                                                return (
                                                    <tr>
                                                        <td>
                                                            {
                                                                GoodsCode
                                                                ?
                                                                `(${GoodsCode}) ${GoodsName}`
                                                                :
                                                                GoodsName
                                                            }
                                                        </td>
                                                        <td>{row.GoodsNameAlias}</td>
                                                        {I18N_LOCALES.map( (locales, index) => {
                                                            if(locales.locale !== ZH_HK) {
                                                                return <><td>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder={""}
                                                                        aria-label="Product Name"
                                                                        value={this.getSupplierProductTranslation(locales.locale,row.GoodsId,GOODS_NAME)}
                                                                        className={`
                                                                        ${!this.getSupplierProductTranslation(locales.locale,row.GoodsId,GOODS_NAME) ? "bg-warning" : ""} 
                                                                        ${this.isSupplierProductSave(locales.locale, row.GoodsId, GOODS_NAME, this.getSupplierProductTranslation(locales.locale,row.GoodsId,GOODS_NAME)) ? "text-success" : ""}
                                                                        `}
                                                                        onChange={(e) => this.handleOnChangeSupplierProduct(locales.locale,row.GoodsId,GOODS_NAME,e.currentTarget.value)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder={""}
                                                                        aria-label="Product Alias"
                                                                        value={this.getSupplierProductTranslation(locales.locale,row.GoodsId,GOODS_NAME_ALIAS)}
                                                                        className={
                                                                        `${!this.getSupplierProductTranslation(locales.locale,row.GoodsId,GOODS_NAME_ALIAS) ? "bg-warning" : ""}
                                                                        ${this.isSupplierProductSave(locales.locale, row.GoodsId, GOODS_NAME_ALIAS, this.getSupplierProductTranslation(locales.locale,row.GoodsId,GOODS_NAME_ALIAS)) ? "text-success" : ""}
                                                                        `}
                                                                        onChange={(e) => this.handleOnChangeSupplierProduct(locales.locale,row.GoodsId,GOODS_NAME_ALIAS,e.currentTarget.value)}
                                                                    />
                                                                </td></>
                                                            }
                                                        })}
                                                    </tr>
                                                )
                                            }
                                        })}
                                    </tbody>
                                </Table>
                            </div>

                            {
                            rowCount === 0
                            ?
                            <div className="mt-2">
                                <Alert className="bg-info text-white"><ExclamationCircle size={16} className="mb-1 mr-1" /><I18N type="ui" path="NO_RESULTS" def="No Results"/></Alert>
                            </div>
                            :
                            <>
                            <div className="mt-4 text-sm-right">
                            <Button 
                                    variant="warning"
                                    onClick={() => this.handleClickSave()}
                                    disabled={this.getConfirmSupplierProductsTranslations().length ? false : true}
                                    >
                                Save
                                </Button>
                            </div>
                            <div className="my-5"></div>
                            </>
                            }

                            </>
                            }
                        </>
                        :
                            <></>
                        }

                        {this.state.mode === 4 && this.state.dataBusiness && this.state.dataUI
                        ?
                            <>
                                <div className="mt-4">

                                    <div className="mt-4">
                                        <h3>Business</h3>
                                    </div>
                                    <div className="mt-4">
                                        <Table bordered hover responsive>
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    {I18N_LOCALES.map( (row, index) => {
                                                        if(row.locale !== ZH_HK) {
                                                            return (
                                                                <th>Name ({row.locale})</th>
                                                            )
                                                        }
                                                    })}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td style={{width:`${COL_WIDTH}px`}}>
                                                        <h2>{this.state.dataBusiness.businessName}</h2>
                                                    </td>
                                                    {I18N_LOCALES.map( (row, index) => {
                                                        if(row.locale !== ZH_HK) {
                                                            return (
                                                                <td>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder={""}
                                                                        aria-label="Business Name"
                                                                        value={this.getBusinessTranslation(row.locale, this.state.dataBusiness.businessId, "BusinessName")}
                                                                        className={`
                                                                            ${
                                                                            this.isBusinessTranslationSave(row.locale, this.state.dataBusiness.businessId, "BusinessName", 
                                                                            this.getBusinessTranslation(row.locale, this.state.dataBusiness.businessId, "BusinessName")) 
                                                                                ? 
                                                                                    "text-success"
                                                                                : 
                                                                                    ""
                                                                            }

                                                                            ${
                                                                                !this.getBusinessTranslation(row.locale, this.state.dataBusiness.businessId, "BusinessName")
                                                                                ?
                                                                                "bg-warning"
                                                                                :
                                                                                ""
                                                                            }
                                                                        `}
                                                                        onChange={(e) => 
                                                                            this.handleOnChangeBusinessTranslation(row.locale, 
                                                                                this.state.dataBusiness.businessId,
                                                                                "BusinessName",
                                                                                e.currentTarget.value
                                                                            )}
                                                                    />
                                                                </td>
                                                            )
                                                        }
                                                    })}
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                    
                                    {this.state.dataBusiness[BRANCHES].map( (branch, index) => {
                                        return (
                                        <>
                                            <div className="mt-4">
                                                <h4>Branch</h4>
                                            </div>
                                            <div className="mt-4">
                                                <Table bordered hover responsive>
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                            {I18N_LOCALES.map( (row, index) => {
                                                                if(row.locale !== ZH_HK) {
                                                                    return (
                                                                        <>
                                                                        <th>Name ({row.locale})</th>
                                                                        <th>Address ({row.locale})</th>   
                                                                        </>
                                                                    )
                                                                }
                                                            })}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{width:`${COL_WIDTH}px`}}>
                                                                <span className="text-primary font-weight-bold">{branch.branchName}</span>
                                                                <br />
                                                                {branch.address}
                                                            </td>
                                                            {I18N_LOCALES.map( (row, index) => {
                                                            if(row.locale !== ZH_HK) {
                                                            return (
                                                            <>
                                                                <td>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder={""}
                                                                        aria-label="Branch Name"
                                                                        value={this.getBranchTranslation(row.locale, this.state.dataBusiness.businessId, branch.branchId, "BranchName")}
                                                                        className={`${
                                                                            this.getBranchTranslation(row.locale, this.state.dataBusiness.businessId, branch.branchId, "BranchName") 
                                                                            ? 
                                                                                "" 
                                                                            : 
                                                                                "bg-warning" 
                                                                            }

                                                                            ${
                                                                                this.isBusinessBranchTranslationSave(row.locale, 
                                                                                    this.state.dataBusiness.businessId, 
                                                                                    branch.branchId, 
                                                                                    "BranchName",
                                                                                    this.getBranchTranslation(row.locale, this.state.dataBusiness.businessId, branch.branchId, "BranchName"))
                                                                                ?
                                                                                    "text-success"
                                                                                :
                                                                                    ""
                                                                            }

                                                                        `}
                                                                        onChange={(e) => 
                                                                            this.handleOnChangeBranchTranslation(row.locale, 
                                                                                this.state.dataBusiness.businessId, 
                                                                                branch.branchId,
                                                                                "BranchName",
                                                                                e.currentTarget.value
                                                                            )}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <Form.Control
                                                                    type="text"
                                                                    placeholder={""}
                                                                    aria-label="Branch Address"
                                                                    value={this.getBranchTranslation(row.locale, this.state.dataBusiness.businessId, branch.branchId, "Address")}
                                                                    className={`${
                                                                        this.getBranchTranslation(row.locale, this.state.dataBusiness.businessId, branch.branchId, "Address") 
                                                                        ? 
                                                                            "" 
                                                                        : 
                                                                            "bg-warning" 
                                                                        }

                                                                        ${
                                                                            this.isBusinessBranchTranslationSave(row.locale, 
                                                                                this.state.dataBusiness.businessId, 
                                                                                branch.branchId, 
                                                                                "Address",
                                                                                this.getBranchTranslation(row.locale, this.state.dataBusiness.businessId, branch.branchId, "Address"))
                                                                            ?
                                                                                "text-success"
                                                                            :
                                                                                ""
                                                                        }
                                                                    `}
                                                                    onChange={(e) => 
                                                                        this.handleOnChangeBranchTranslation(row.locale, 
                                                                            this.state.dataBusiness.businessId, 
                                                                            branch.branchId,
                                                                            "Address",
                                                                            e.currentTarget.value
                                                                        )}
                                                                    />
                                                                </td>
                                                            </>
                                                            )}
                                                            })}
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>
                                            <div className="mt-4">
                                                <h5>Departments</h5>
                                            </div>
                                            <div className="mt-4">
                                                <Table bordered hover responsive>
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                            {I18N_LOCALES.map( (row, index) => {
                                                                if(row.locale !== ZH_HK) {
                                                                    return <th>Name ({row.locale})</th>
                                                                }
                                                            })}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {branch[DEPARTMENTS].map && branch[DEPARTMENTS].map( (department, index) => {
                                                        return <tr>
                                                            <td style={{width:`${COL_WIDTH}px`}}>{department.DepName}</td>
                                                            {I18N_LOCALES.map( (row, index) => {
                                                            if(row.locale !== ZH_HK) {
                                                            return (
                                                            <td>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder={""}
                                                                    aria-label="Department Name"
                                                                    value={this.getDepartmentTranslation(row.locale, this.state.dataBusiness.businessId, branch.branchId, department.DepId)}
                                                                    className={`${
                                                                        this.getDepartmentTranslation(row.locale, this.state.dataBusiness.businessId, branch.branchId, department.DepId) 
                                                                        ? 
                                                                            "" : 
                                                                            "bg-warning"
                                                                        }

                                                                        ${
                                                                            this.isBusinessBranchDepartmentTranslationSave(row.locale, 
                                                                                this.state.dataBusiness.businessId, 
                                                                                branch.branchId,
                                                                                department.DepId,
                                                                                this.getDepartmentTranslation(row.locale, this.state.dataBusiness.businessId, branch.branchId, department.DepId))
                                                                            ?
                                                                                "text-success"
                                                                            :
                                                                                ""
                                                                        }

                                                                    `}
                                                                    onChange={(e) => 
                                                                        this.handleOnChangeDepartmentTranslation(row.locale, 
                                                                            this.state.dataBusiness.businessId, 
                                                                            branch.branchId, 
                                                                            department.DepId, 
                                                                            e.currentTarget.value
                                                                        )}
                                                                />
                                                            </td>
                                                            )}
                                                            })}
                                                        </tr>
                                                        })}
                                                    </tbody>
                                                </Table>
                                            </div>

                                            <div className="mt-4">
                                                <h5>Storages</h5>
                                            </div>
                                            <div className="mt-4">
                                                <Table bordered hover responsive>
                                                    <thead>
                                                        <tr>
                                                        <th>Name</th>
                                                            {I18N_LOCALES.map( (row, index) => {
                                                                if(row.locale !== ZH_HK) {
                                                                    return <th>Name ({row.locale})</th>
                                                                }
                                                            })}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {branch[STORAGES].map && branch[STORAGES].map( (storage, index) => {
                                                        return <tr>
                                                            <td style={{width:`${COL_WIDTH}px`}}>{storage.StorageName}</td>
                                                            {I18N_LOCALES.map( (row, index) => {
                                                                if(row.locale !== ZH_HK) {
                                                                    return (
                                                                    <td>
                                                                        <Form.Control
                                                                            type="text"
                                                                            placeholder={""}
                                                                            aria-label="Storage Name"
                                                                            value={this.getStorageTranslation(row.locale, this.state.dataBusiness.businessId, branch.branchId, storage.StorageId)}
                                                                            className={`
                                                                                ${
                                                                                this.getStorageTranslation(row.locale, this.state.dataBusiness.businessId, branch.branchId, storage.StorageId) 
                                                                                    ? 
                                                                                    "" 
                                                                                    : 
                                                                                    "bg-warning"
                                                                                }

                                                                                ${
                                                                                    this.isBusinessBranchStorageTranslationSave(row.locale, 
                                                                                        this.state.dataBusiness.businessId, 
                                                                                        branch.branchId,
                                                                                        storage.StorageId,
                                                                                        this.getStorageTranslation(row.locale, this.state.dataBusiness.businessId, branch.branchId, storage.StorageId))
                                                                                    ?
                                                                                        "text-success"
                                                                                    :
                                                                                        ""
                                                                                }
                                                                            `}
                                                                            onChange={(e) => this.handleOnChangeStorageTranslation(row.locale, 
                                                                                this.state.dataBusiness.businessId, 
                                                                                branch.branchId, 
                                                                                storage.StorageId, 
                                                                                e.currentTarget.value)}
                                                                        />
                                                                    </td>
                                                                )}
                                                            })}
                                                        </tr>
                                                    })}
                                                    </tbody>
                                                </Table>
                                            </div>
                                            <hr className="my-4" />
                                        </>
                                    )})}
                                </div>
                                <div className="mt-4 text-sm-right">
                                    <Button 
                                        variant="warning"
                                        onClick={() => this.handleClickSave()}
                                        disabled={this.isConfirmBusinessTranslations() ? false : true}
                                        >
                                    Save
                                    </Button>
                                </div>
                                <div className="my-5"></div>
                            </>
                        :
                            <></>
                        }

                        {(this.state.mode === 5 && this.state.dataSuppliers)
                        ?
                            <>
                            <div className="mt-4">
                                <Table bordered hover responsive>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            {I18N_LOCALES.map( (locales, index) => {
                                                let locale = locales.locale;
                                                if(locale !== ZH_HK) {
                                                    return (<>
                                                        <th>Name ({locale})</th>
                                                        <th>Address ({locale})</th>
                                                    </>)
                                                }
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.dataSuppliers.map( (supplier, index) => {
                                            return (<tr>
                                                <td style={{width:`${COL_WIDTH}px`}}>
                                                    <span className="text-primary font-weight-bold">{supplier.SupplierName}</span>
                                                    <br />
                                                    {supplier.Address}
                                                </td>
                                                {I18N_LOCALES.map( (locales, index) => {
                                                let locale = locales.locale;
                                                if(locale !== ZH_HK) {
                                                    return (<>
                                                    <td>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder={""}
                                                            aria-label="Supplier Name"
                                                            value={this.getSuppliersTranslation(locale, supplier.SupplierId, 'SupplierName')}
                                                            className={`
                                                                ${
                                                                this.getSuppliersTranslation(locale, supplier.SupplierId, 'SupplierName') 
                                                                    ? 
                                                                    "" 
                                                                    : 
                                                                    "bg-warning"
                                                                }

                                                                ${
                                                                    this.isSuppliersTranslationSave(locale, supplier.SupplierId, 'SupplierName', this.getSuppliersTranslation(locale, supplier.SupplierId, 'SupplierName'))
                                                                    ?
                                                                        "text-success"
                                                                    :
                                                                        ""
                                                                }
                                                            `}
                                                            onChange={(e) => this.handleOnChangeSuppliersTranslation(locale, 
                                                                supplier.SupplierId,
                                                                'SupplierName',
                                                                e.currentTarget.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder={""}
                                                            aria-label="Supplier Address"
                                                            value={this.getSuppliersTranslation(locale, supplier.SupplierId, 'Address')}
                                                            className={`
                                                                ${
                                                                this.getSuppliersTranslation(locale, supplier.SupplierId, 'Address') 
                                                                    ? 
                                                                    "" 
                                                                    : 
                                                                    "bg-warning"
                                                                }

                                                                ${
                                                                    this.isSuppliersTranslationSave(locale, supplier.SupplierId, 'Address', this.getSuppliersTranslation(locale, supplier.SupplierId, 'Address'))
                                                                    ?
                                                                        "text-success"
                                                                    :
                                                                        ""
                                                                }
                                                            `}
                                                            onChange={(e) => this.handleOnChangeSuppliersTranslation(locale, 
                                                                supplier.SupplierId,
                                                                'Address',
                                                                e.currentTarget.value)}
                                                        />
                                                    </td>
                                                    </>);
                                                }
                                                })}
                                            </tr>)
                                        })}
                                    </tbody>
                                </Table>
                            </div>
                            <div className="mt-4 text-sm-right">
                            <Button 
                                    variant="warning"
                                    onClick={() => this.handleClickSave()}
                                    disabled={this.getConfirmSupplierTranslations().length ? false : true}
                                    >
                                Save
                                </Button>
                            </div>
                            <div className="my-5"></div>
                            </>
                        :
                            <></>
                        }

                    </>
                            }
                        </Col>
                    </Row>
                </Container>
            </Container>
            <FooterComponent />
            {(this.state.mode === 1 && this.state.data) || 
                (this.state.mode === 2) || 
                (this.state.mode === 3) || 
                (this.state.mode === 4 && this.state.dataBusiness && this.state.dataUI) ||
                (this.state.mode === 5 && this.state.dataSuppliers && this.state.dataUI) 
            ?
            <Modal 
                show={this.state.isConfirmModal} 
                onHide={this.handleConfirmModalClose}
                size="xl">
                <Modal.Header closeButton>
                <Modal.Title>Confirm</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    {this.state.mode === 1 && Object.keys(this.state.data).length > 0 &&
                    <>
                    <Table bordered hover responsive className="mt-4">
                    <thead>
                        <tr>
                            <th>Name</th>
                            {this.state.data[Object.keys(this.state.data)[0]].map( (obj, index) => {
                                return (
                                    <th>Translation ({obj.locale})</th>
                                )
                            })}
                        </tr>
                    </thead>
                    <tbody>
                    {
                    Object.keys(this.getConfirmTranslations()).length
                    ?
                        Object.keys(this.getConfirmTranslations()).map( (key, index) => {
                            return <tr>
                            <td>{key}</td>
                            {this.state.dataUI[Object.keys(this.state.data)[0]].map( (obj, index) => {
                                let i = this.getConfirmTranslations()[key].findIndex( (row) => row.locale === obj.locale );
                                return (
                                    i > -1
                                    ?
                                    <td>{JSON.stringify(this.getConfirmTranslations()[key][i].translation)}</td>
                                    :
                                    <td></td>
                                )
                            })}
                            </tr>
                        })
                    :
                    <></>
                    }
                    </tbody>
                    </Table>
                    </>
                    }

                    {this.state.mode === 2
                    ?
                    <>
                    <Table bordered hover responsive className="mt-4">
                    <thead>
                        <tr>
                            <th>Unit</th>
                            {I18N_LOCALES.map( (locales, index) => {
                                 if(locales.locale !== ZH_HK) {
                                    return (
                                        <th>Translation ({locales.locale})</th>
                                    )
                                }    
                            })}
                        </tr>
                    </thead>
                    <tbody>
                            {this.getConfirmUnitTranslations().map( (unit, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{unit.unitName}</td>
                                        <td>{unit.translation}</td>
                                    </tr>
                                )
                            })}
                    </tbody>
                    </Table>
                    </>
                    :
                    <></>
                    }

                    {this.state.mode === 3
                    ?
                    <>
                    <Table bordered hover responsive className="mt-4">
                    <thead>
                        <tr>
                            <th>Product Name</th>
                            <th>Product Alias</th>
                            {I18N_LOCALES.map( (locales, index) => {
                                 if(locales.locale !== ZH_HK) {
                                    return (
                                        <>
                                            <th>Product Name ({locales.locale})</th>
                                            <th>Product Alias ({locales.locale})</th>
                                        </>
                                    )
                                }    
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {this.getConfirmSupplierProductsTranslations().map( (row, index) => {
                                const goodsCode = this.getSupplierProductProperty(row.GoodsId,GOODS_CODE);
                                const goodsName = this.getSupplierProductProperty(row.GoodsId,GOODS_NAME);
                                return (
                                    <tr key={index}>
                                        <td>
                                            {
                                                goodsCode
                                                ?
                                                `(${goodsCode}) ${goodsName}`
                                                :
                                                goodsName
                                            }
                                        </td>
                                        <td>{this.getSupplierProductProperty(row.GoodsId,GOODS_NAME_ALIAS)}</td>
                                        <td>{row.GoodsName}</td>
                                        <td>{row.GoodsNameAlias}</td>
                                    </tr>
                                )
                        })}
                    </tbody>
                    </Table>
                    </>
                    :
                    <></>
                    }
                
                    {this.state.mode === 4
                    ?
                        <>
                            {this.getConfirmBusinessTranslationsHTML()}
                        </>
                    :
                        <></>
                    }

                    {this.state.mode === 5
                    ?
                    <>
                    <Table bordered hover responsive className="mt-4">
                    <thead>
                        <tr>
                            <th>Name</th>
                            {I18N_LOCALES.map( (locales, index) => {
                                 if(locales.locale !== ZH_HK) {
                                    return (
                                        <>
                                            <th>Name ({locales.locale})</th>
                                            <th>Address ({locales.locale})</th>
                                        </>
                                    )
                                }    
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {this.getConfirmSupplierTranslations().map( (row, index) => {
                                return (
                                    <tr key={index}>
                                        <td>
                                            <span className="text-primary font-weight-bold">{this.getSuppliersProperty(row.SupplierId, 'SupplierName')}</span>
                                            <br />
                                            {this.getSuppliersProperty(row.SupplierId, 'Address')}
                                        </td>
                                        <td>{row.SupplierName}</td>
                                        <td>{row.Address}</td>
                                    </tr>
                                )
                        })}
                    </tbody>
                    </Table>
                    </>
                    :
                    <></>
                    }

                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={this.handleConfirmModalClose}>
                    Close
                </Button>
                <Button 
                    variant="primary" 
                    onClick={this.handleConfirmModalSave}
                    disabled={this.state.isConfirmLoading ? true: false}
                >
                    {!this.state.isConfirmLoading ? "Save" : "Loading.."}
                </Button>
                </Modal.Footer>
            </Modal>
            :
            <></>
            }

            <Modal 
                show={this.state.isAddUIModal} 
                onHide={this.handleAddUIModalClose}
                size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Add UI Translation</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="mt-4">
                        <AlertComponent
                            variant="warning"
                            label={"Name format: A-Z and underscores"}
                        />
                    </div>

                    {this.isTranslationSaveNameError() &&
                    <div className="my-4">
                        <AlertComponent
                            label={"Translation name already taken"}
                        />
                    </div>
                    }

                    {this.isTranslationNameFormatError() &&
                    <div className="my-4">
                        <AlertComponent
                            label={"Translation name format error"}
                        />
                    </div>
                    }

                    <Table bordered hover responsive>
                        <thead>
                            <tr>
                                <th>
                                    Name
                                </th>
                                {I18N_LOCALES.map( (locales, index) => {
                                    return (
                                        <>
                                            <th>Translation ({locales.locale})</th>
                                        </>
                                    )
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <Form.Control
                                        type="text"
                                        placeholder=""
                                        aria-label="Translation"
                                        value={this.state.dataAddUI["name"]}
                                        onChange={(e) => this.handleOnChangeAddUIName(e.currentTarget.value) }
                                    />
                                </td>
                                {I18N_LOCALES.map( (locales, index) => {
                                    return (
                                        <>
                                            <td>
                                                <Form.Control
                                                    type="text"
                                                    placeholder=""
                                                    aria-label="Translation"
                                                    value={this.state.dataAddUI["translations"][locales.locale]}
                                                    onChange={(e) => this.handleOnChangeAddUITranslation(locales.locale, e.currentTarget.value) }
                                                />
                                            </td>
                                        </>
                                    )
                                })}
                            </tr>
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={this.handleAddUIModalClose}>
                    Close
                </Button>
                <Button 
                    variant="primary" 
                    onClick={this.handleAddUIModalSave}
                    disabled={this.disabledAddUIModal() ? true: false}
                >
                    {!this.state.isConfirmLoading ? "Save" : "Loading.."}
                </Button>
                </Modal.Footer>
            </Modal>

            </>
        )
    }
}

const mapStateToProps = state => {
    const {auth, i18n} = state;
    return { auth: auth, i18n: i18n };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(I18NTranslations));